import React from 'react';
import ContactForm from '../ContactFrom'
import './style.css'
import PageTitle from '../pagetitle'
import contactBanner from '../../images/banners/contact.webp'

const Contactpage = () => {

    return(
        <>
            {/* <PageTitle pageTitle={'Contact'} pagesub={'Contact'} backgroundImage={contactBanner} /> */}
            <section className="wpo-contact-form-map section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className="col col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="contact-form">
                                        <h2>Get In Touch</h2>
                                        <ContactForm/>
                                    </div>
                                </div>
                            </div>
                            <div className="wpo-contact-info">
                                <div className="row">
                                    <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                                        <div className="info-item">
                                            <h2><a href="https://goo.gl/maps/UzpCUaZEiDmzNT2f6" target="_blank" rel="noopener noreferrer">London, UK</a></h2>
                                            <div className="info-wrap">
                                                <div className="info-icon">
                                                    <i className="ti-world"></i>
                                                </div>
                                                <div className="info-text">
                                                    <span>Our Location</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                                        <div className="info-item">
                                            <h2><a href="mailto:info@theedarulqurran.com">info@theedarulqurran.com</a></h2>
                                            <div className="info-wrap">
                                                <div className="info-icon-2">
                                                    <i className="fi flaticon-envelope"></i>
                                                </div>
                                                <div className="info-text">
                                                    <span>Official Email</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                                        <div className="info-item">
                                            <h2><a href="https://wa.me/message/UTB4XLJQLZ22M1">+44 784 035 7821</a></h2>
                                            <div className="info-wrap">
                                                <div className="info-icon-3">
                                                    <i className="ti-headphone-alt"></i>
                                                </div>
                                                <div className="info-text">
                                                    <span>Contact Number</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
     )
        
}

export default Contactpage;
